import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Service
import ItemService from "../../../services/supplier_appCommonService";
import ApproveRemarksModal from "../../../Components/Modal/supplier_app/ApproveRemarksModal";
import SuccessModal from "../../../Components/Modal/supplier_app/SuccessModal";
import Constants from "../../../common/Constants";

const WorkflowApproveReject = (props) => {
  // eslint-disable-next-line
  const [isInitialized, setIsInitialized] = useState(false);
  const [workflow, setWorkflow] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [getAction, setAction] = useState("");

  const successModalData = { title: "Message", successMsg: "" };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getNextNavigate, setNextNavigate] = useState("");

  useEffect(() => {
    if (props?.workflowData) {
      setWorkflow(props?.workflowData);
      setIsInitialized(true);
    }
  }, [props?.workflowData]);

  const onSuccessmodel = () => setShowSuccessModal(true);
  const hideSuccessModal = () => setShowSuccessModal(false);
  const navigateToWorkflow = () => window.history.back();

  const showApproveModal = async (name) => {
    setModalShow(true);
    setAction(name);
  };

  const workflowApproveReject = async (remarks) => {
    let bodyObj = workflow?.workflowActionAPI?.Body;

    let obj = {
      _id: workflow?._id,
      businessComponentId: workflow?.businessComponentId,
      eventId: workflow?.eventId,
      businessComponentInstanceId: workflow?.businessComponentInstanceId,
      stepId: workflow?.stepId,
      action: getAction,
      remark: remarks,
      editContextData: workflow?.editContextData,
      editForm: workflow?.editForm,
      data: { ...props?.formInputsData },
    };

    let newObj = { ...bodyObj, ...obj };

    await ItemService.workflowApproveReject(newObj).then((item) => {
      if (item?.status === 200) {
        successModalData.successMsg =
          getAction === "Approve"
            ? "Approved Successfully !!"
            : "Rejected Successfully !!";
        setsucceModalData(successModalData);
        setNextNavigate(Constants.INBOX);
        onSuccessmodel();
      } else {
        console.log(">> Error: Loading workflowApproveReject");
      }
    });
  };

  const handleValueChange = (remarks) => workflowApproveReject(remarks);
  const hideModal = () => setModalShow(false);

  return (
    <>
      <Row className="mb-4 align-items-center">
        {/* Go Back — Left */}
        <Col xs={12} md={4} lg={4}>
          <button className="btnBack" onClick={navigateToWorkflow}>
            <i className="bi bi-arrow-return-left"></i> Go Back
          </button>
        </Col>

        {/* Approve / Reject — Right */}
        <Col
          xs={12}
          md={8}
          lg={8}
          className="d-flex justify-content-end align-items-center gap-2 flex-wrap"
        >
          {workflow?.decision?.length > 0 &&
            workflow?.decision?.map((item, index) => (
              <button
                key={index}
                className={
                  item === "Approve" || item === "Submit"
                    ? "btnCommon btn-approve"
                    : "btnCommon btn-danger"
                }
                onClick={() => showApproveModal(item)}
              >
                <i
                  className={
                    item === "Approve" || item === "Submit"
                      ? "bi bi-check2-circle"
                      : "bi bi-x-circle"
                  }
                ></i>{" "}
                {item}
              </button>
            ))}
        </Col>
      </Row>

      {/* Modals */}
      <SuccessModal
        show={getShowSuccessModal}
        onHide={hideSuccessModal}
        successmodaldata={getsucceModalData}
        nextnavigate={getNextNavigate}
      />
      <ApproveRemarksModal
        show={modalShow}
        onHide={hideModal}
        onvaluechange={handleValueChange}
      />
    </>
  );
};

export default WorkflowApproveReject;
